import React from 'react';
import moment from 'moment';
import {Box} from '@mui/material';
import {gridCellDef} from './GridCellDef';

export const renderCellDate: gridCellDef<unknown> = (params) => {
  return (
    <Box flex={1} textAlign="center" alignContent="center" justifyContent="center">
      {params.value ? moment(params.value?.valueOf()).format('DD/MM/YY') : 'N/A'}
    </Box>
  );
};
